
export class UrlRedirection {

  public urlRedirectionID: number;
  public id: string;
  public oldUrl: string;
  public newUrl: string;
  public type: string;
  public isActive: boolean;

}



// WEBPACK FOOTER //
// ./src/app/models/shared/url-redirection.model.ts